export default __webpack_public_path__ + "static/media/actual-home.b9e8ea33.png";